import Vue from "vue";
import App from "./App.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import store from "./store/store.js";
import directives from "./global/directives";
import router from "./router"; 
import "./styles/main.scss";
import VueDragResize from "vue-drag-resize";

import {
    faChevronRight,
    faChevronLeft,
    faCheck,
    faCheckCircle,
    faTimesCircle,
    faSlidersH,
    faChevronDown,
    faExclamationCircle,
    faInfo,
    faStar,
    faTimes,
    faSearch,
    faAngleDown,
    faTrashAlt,
    faCopy,
    faFlag,
    faAngleUp,
    faGlobe,
    faTrash,
    faPlusSquare
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faChevronRight,
    faChevronLeft,
    faCheck,
    faCheckCircle,
    faTimesCircle,
    faSlidersH,
    faChevronDown,
    faExclamationCircle,
    faInfo,
    faStar,
    faTimes,
    faSearch,
    faAngleDown,
    faAngleUp,
    faTrashAlt,
    faCopy,
    faFlag,
    faTrash,
    faGlobe,
    faPlusSquare
);

Vue.component("vue-drag-resize", VueDragResize);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.directive("click-outside", directives.clickOutside);

Vue.config.productionTip = false; // Disable production buildtips in the console
Vue.config.ignoredElements = [/^div-col-/]; // Allow custom elements that start with div-col-. This is used for the column property in the SR and MR questions


new Vue({
    store,
    router,
    render: (h) => h(App),
}).$mount("#app");
